package pl.decks.personal.pages.blog

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant

@Composable
fun NavigableTag(
    tag: String,
    currentTags: List<String>,
    content: @Composable () -> Unit
) = Link(getTagTarget(tag, currentTags), variant = UndecoratedLinkVariant) {
    content()
}

private fun getTagTarget(tag: String, currentTags: List<String>): String {
    val isSelected = currentTags.contains(tag)
    val tagsAfterClick = if (isSelected) currentTags - tag else currentTags + tag
    return if (tagsAfterClick.isEmpty()) "/blog" else "/blog?filterTags=${tagsAfterClick.joinToString(",")}"
}
